module.exports = __webpack_public_path__ + "static/img/plate.a6b4f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/pop/plate.png
// module id = HqsW
// module chunks = 2